import React from 'react';
import DashboardLayout from '../../components/dashboard/DashboardLayout';
import { useAuth } from '../../contexts/AuthContext';
import SEO from '../../components/SEO';
import PatientDashboard from './PatientDashboard';
import DoctorDashboard from './DoctorDashboard';
import ClinicDashboard from './ClinicDashboard';
import LabDashboard from './LabDashboard';

const HealthTrackPro = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <DashboardLayout title="HealthTrack Pro">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600"></div>
        </div>
      </DashboardLayout>
    );
  }

  const role = user?.role;

  const renderDashboard = () => {
    switch (role) {
      case 'doctor':
      case 'admin':
      case 'superadmin':
        return <DoctorDashboard />;
      case 'clinic':
        return <ClinicDashboard />;
      case 'lab':
        return <LabDashboard />;
      case 'patient':
      case 'user':
      default:
        return <PatientDashboard />;
    }
  };

  return (
    <DashboardLayout title="HealthTrack Pro">
      <SEO
        title="HealthTrack Pro - AI-Powered Health Management | Infuse-AI"
        description="Manage patient records, appointments, and health insights with HealthTrack Pro"
        keywords="health management, patient records, appointments, healthcare platform"
      />
      {renderDashboard()}
    </DashboardLayout>
  );
};

export default HealthTrackPro;
